<dcp-configurator-single-page-form [hideConfiguration]="hideConfiguration">
  <dcp-configure-service-error (configureServiceError)="hideConfiguration = $event.hasError"></dcp-configure-service-error>
</dcp-configurator-single-page-form>
